import React, { useState } from "react";
import { ChevronDown, MapPin, Building2 } from "lucide-react";
import { useOutlets } from "./OutletContext";

const TYPE_ICONS = {
  restaurant: Building2,
  bar: Building2,
  hotel: Building2,
  cafe: Building2,
  catering: Building2,
  other: Building2,
};

export default function OutletSwitcher() {
  const { outlets, activeOutlet, switchOutlet, meta } = useOutlets();
  const [open, setOpen] = useState(false);

  if (!activeOutlet) return null;
  const multi = outlets.length > 1;
  const Icon = TYPE_ICONS[activeOutlet.type] || Building2;

  // Single outlet: render readonly badge
  if (!multi) {
    return (
      <div className="mx-3 mb-1 px-3 py-2 rounded-md border border-white/8 bg-white/[0.02] flex items-center gap-2" data-testid="outlet-switcher-single">
        <Icon size={13} className="text-ink-muted shrink-0" />
        <div className="min-w-0 flex-1">
          <div className="text-[10px] uppercase tracking-wider text-ink-muted">Outlet</div>
          <div className="text-xs font-medium text-ink-primary truncate">{activeOutlet.name}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="relative mx-3 mb-1" data-testid="outlet-switcher">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full px-3 py-2 rounded-md border border-white/10 bg-white/[0.02] hover:bg-white/[0.05] flex items-center gap-2 transition-colors"
        data-testid="outlet-switcher-btn"
      >
        <Icon size={13} className="text-brand shrink-0" />
        <div className="min-w-0 flex-1 text-left">
          <div className="text-[10px] uppercase tracking-wider text-brand">Aktives Outlet</div>
          <div className="text-xs font-medium text-ink-primary truncate">{activeOutlet.name}</div>
        </div>
        <ChevronDown size={12} className={`text-ink-muted shrink-0 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute left-0 right-0 mt-1 bg-bg-void border border-white/10 rounded-md shadow-glow z-40 max-h-72 overflow-y-auto" data-testid="outlet-switcher-list">
          {outlets.map((o) => (
            <button
              key={o.id}
              type="button"
              onClick={() => { switchOutlet(o.id); setOpen(false); window.location.reload(); }}
              className={`w-full px-3 py-2 text-left text-xs hover:bg-white/[0.05] flex items-center gap-2 ${o.id === activeOutlet.id ? "bg-brand/10 text-brand" : "text-ink-primary"}`}
              data-testid={`outlet-pick-${o.id}`}
            >
              <MapPin size={11} className="shrink-0 opacity-60" />
              <div className="min-w-0 flex-1">
                <div className="truncate font-medium">{o.name}</div>
                <div className="text-[10px] opacity-60">{o.type}{o.is_default ? " · Standard" : ""}</div>
              </div>
            </button>
          ))}
          {meta?.is_multi_outlet_plan && outlets.length < (meta.max_allowed || 5) && (
            <a href="/outlets" className="block px-3 py-2 text-[11px] text-brand hover:bg-brand/10 border-t border-white/5" data-testid="outlet-manage">
              + Outlets verwalten
            </a>
          )}
        </div>
      )}
    </div>
  );
}
